import React, { useEffect, useRef, useState, useCallback } from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { Tooltip, Menu, Dropdown, Input, Radio, message } from 'antd';
import { apiHolder as api, apis, util, } from 'api';
import style from './index.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
import { useAppSelector, useAppDispatch, MailTabActions } from '@web-common/state/createStore';
import { actions as mailActions } from '@web-common/state/reducer/mailReducer';
import { actions as mailConfigActions } from '@web-common/state/reducer/mailConfigReducer';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import useHideNicknameSetting from '@web-common/hooks/useHideNicknameSetting';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import classnames from 'classnames';
import NicknameSettingIcon from '@web-common/components/UI/Icons/svgs/mail/NicknameSettingIcon';
import MailSenderSetting, { SenderSettingType } from '@web-common/components/MailSenderDialog/mailSenderSetting';
import { AlertErrorIcon } from '@web-common/components/UI/Icons/icons';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { actions as attachmentActions } from '@web-common/state/reducer/attachmentReducer';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = api.api.requireLogicalApi(apis.mailConfApiImpl);
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const systemApi = api.api.getSystemApi();
const inElectron = systemApi.isElectron();
const AccountTag = (props) => {
    const { senderName = '', isDefault = false, id: email, isSelected = false, agentEmail } = props.account;
    const hasEmail = email && email.length > 2;
    const emailRef = useRef(null);
    const emailMeasureRef = useRef(null);
    const [showTooltip, setShowTooltip] = useState(false);
    const emailShowName = agentEmail && agentEmail.length > 2 && agentEmail !== email ? agentEmail : email;
    const handleShowTooltip = () => {
        var _a, _b;
        const truncateWidth = ((_a = emailRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0;
        const originalWidth = ((_b = emailMeasureRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
        setShowTooltip(originalWidth > truncateWidth);
    };
    const renderContent = () => (React.createElement("div", { className: classnames(style.senderMenuItemName, isSelected ? style.senderMenuItemSelected : ''), onMouseEnter: handleShowTooltip },
        React.createElement("span", null, util.chopStrToSize(senderName, hasEmail ? 6 : 12)),
        "\u00A0\u00A0",
        React.createElement("div", { ref: emailRef, className: !isSelected ? style.senderMenuItemNameMail : '', style: { textOverflow: 'ellipsis', overflow: 'hidden', maxWidth: 200 } }, hasEmail ? `${emailShowName}` : ''),
        React.createElement("div", { ref: emailMeasureRef, className: !isSelected ? style.senderMenuItemNameMail : '', style: { visibility: 'hidden', height: 0, position: 'absolute' } }, hasEmail ? `${util.chopStrToSize(agentEmail, 22)}` : ''),
        isDefault ? React.createElement("span", { className: style.defaultSender }, getIn18Text('MOREN')) : null));
    return showTooltip ? (React.createElement(Tooltip, { title: React.createElement("div", null,
            React.createElement("div", null, senderName),
            React.createElement("div", null, agentEmail)), mouseEnterDelay: 0.3, mouseLeaveDelay: 0.15, zIndex: 9999, placement: "right" }, renderContent())) : (renderContent());
};
const SenderSelect = prop => {
    var _a, _b;
    const dispatch = useAppDispatch();
    const { selectChanged } = prop;
    const [selectableAccounts, setSelectableAccounts] = useState([]);
    const [curAccount, setCurAccount] = useState({ name: '', id: '', domain: '', nickName: '', senderName: '' });
    const currentMailId = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.cid; });
    const { currentMail } = useAppSelector(state => state.mailReducer);
    const { attachments } = useAppSelector(state => state.attachmentReducer);
    const praiseMailShow = (_a = currentMail.status) === null || _a === void 0 ? void 0 : _a.praiseMailShow;
    const taskMailShow = (_b = currentMail.status) === null || _b === void 0 ? void 0 : _b.taskMailShow;
    const [tempNickName, setTempNickName] = useState('');
    const [isEditting, setIsEditting] = useState(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [showSenderSettingDialog, setShowSenderSettingDialog] = useState(false);
    const hideNickname = useHideNicknameSetting();
    const inputRef = useRef(null);
    const selectableAccountsRef = useRef(selectableAccounts);
    selectableAccountsRef.current = selectableAccounts;
    const keydownAction = useCallback(e => {
        if (e.keyCode === 13 && isEditting) {
            handleNicknameChangeBlur(e);
        }
    }, [isEditting]);
    const getSubAccounts = async () => {
        try {
            const subAccounts = await accountApi.getSubAccounts({ expired: false });
            return (subAccounts === null || subAccounts === void 0 ? void 0 : subAccounts.length) ? subAccounts : [];
        }
        catch (error) {
            console.log('获取子账号失败', error);
            return [];
        }
    };
    const getSubAccountsSenderName = async () => {
        try {
            let senderNameMap = new Map();
            let allQiyeReq = [];
            let allQiyeAccountEmail = [];
            let allQiyeAccountNickName = [];
            const accounts = await accountApi.getAllSubAccounts();
            for (let i = 0; i < accounts.length; i++) {
                let nickName = accounts[i].agentNickname || accounts[i].accountName || '';
                if (accounts[i].accountType === 'qyEmail') {
                    allQiyeReq.push(accountApi.getQiyeMailSubAccountNickName({ email: accounts[i].accountEmail }));
                    allQiyeAccountEmail.push(accounts[i].agentEmail);
                    allQiyeAccountNickName.push(nickName);
                }
                else {
                    senderNameMap.set(accounts[i].agentEmail, nickName);
                }
            }
            const qiyeRes = await Promise.allSettled(allQiyeReq);
            qiyeRes.forEach((_, i) => {
                var _a;
                const _res = (_ === null || _ === void 0 ? void 0 : _.value) || (_ === null || _ === void 0 ? void 0 : _.reason);
                let onNickname = ((_a = _res === null || _res === void 0 ? void 0 : _res.data) === null || _a === void 0 ? void 0 : _a.nickName) || allQiyeAccountNickName[i] || '';
                senderNameMap.set(allQiyeAccountEmail[i], onNickname);
            });
            return senderNameMap;
        }
        catch (error) {
            console.log('获取子账号发件人昵称失败', error);
            return new Map();
        }
    };
    const getSelectableAccounts = useCreateCallbackForEvent(async () => {
        let mainAndAliaAccounts = await mailConfApi.getMailSenderInfo();
        mainAndAliaAccounts = mainAndAliaAccounts.map(item => (Object.assign(Object.assign({}, item), { isMainAccount: true })));
        let subAccounts = [];
        const mainAccount = mainAndAliaAccounts.find(async (account) => !!account.isMainEmail);
        if (mainAccount) {
            const subAccountsRes = await getSubAccounts();
            const subAccountsSenderName = await getSubAccountsSenderName();
            if (subAccountsRes === null || subAccountsRes === void 0 ? void 0 : subAccountsRes.length) {
                subAccounts = subAccountsRes.map((item) => {
                    const { id, accountName, nickName, agentEmail } = item;
                    const _senderName = agentEmail ? subAccountsSenderName.get(agentEmail) : '';
                    return Object.assign({ isMainEmail: true, name: accountName, mailEmail: id, senderName: _senderName || nickName, isMainAccount: false, agentEmail: agentEmail, isSubAccount: true }, item);
                });
            }
        }
        let selectableAccounts = [];
        selectableAccounts = [...mainAndAliaAccounts, ...subAccounts];
        setSelectableAccounts(selectableAccounts);
        return selectableAccounts;
    });
    const setOptSenderAction = (selectedEmail) => {
        let optSender = selectableAccountsRef.current.find(item => item.id === selectedEmail);
        if (!optSender)
            return;
        if (currentMail.isDyncGroupSend) {
            if (optSender === null || optSender === void 0 ? void 0 : optSender.isSubAccount) {
                message.warn(getIn18Text('FEIZHUZHANGHGZYXZBZC6'));
                return;
            }
        }
        optSender.currentMailCid = currentMailId;
        setCurAccount(optSender);
        setTempNickName(optSender.senderName || '');
        dispatch(mailConfigActions.doSetNickname(optSender.senderName || ''));
        dispatch(mailActions.doModifyOptSender(optSender));
        dispatch(mailActions.doModifyOptSenderMainEmail(optSender.mailEmail || optSender.id));
        if (optSender) {
            selectChanged({ id: optSender.id, nickName: optSender.senderName, mailEmail: optSender.mailEmail || '' });
        }
        else {
            selectChanged(null);
        }
        reInitMail(selectedEmail);
    };
    const selectedEmailRef = useRef('');
    const doReSendInitMailEmail = useRef('');
    const reInitMail = async (selectedEmail) => {
        var _a, _b;
        if (currentMailId && selectedEmailRef.current && selectedEmailRef.current !== selectedEmail) {
            const currentMailDB = await mailApi.doGetMailFromDB(currentMailId);
            const hasAttachments = (_b = (_a = currentMailDB === null || currentMailDB === void 0 ? void 0 : currentMailDB.entry) === null || _a === void 0 ? void 0 : _a.attachment) === null || _b === void 0 ? void 0 : _b.filter(item => !item.deleted).some(item => !(item.type === 'netfolder' || !!item.cloudAttachment));
            if (!hasAttachments) {
                try {
                    doReSendInitMailEmail.current = selectedEmail;
                    const newContent = await mailApi.doReSendInitMail(currentMailId, selectedEmail, true);
                    if (selectedEmail === doReSendInitMailEmail.current) {
                        const newCid = (newContent === null || newContent === void 0 ? void 0 : newContent.cid) || '';
                        if (newCid) {
                            const oldCid = currentMailId;
                            dispatch(mailActions.doReplaceCid({ cid: oldCid, newCid, _account: selectedEmail, mailEditStatus: '' }));
                            dispatch(MailTabActions.doReplaceTabId({ oldId: String(oldCid), newId: String(newCid) }));
                            const oldAttachments = attachments.filter(item => item.mailId === oldCid) || [];
                            const newAttachments = oldAttachments.map(item => (Object.assign(Object.assign({}, item), { mailId: newCid })));
                            dispatch(attachmentActions.cloneAttachments(newAttachments));
                            dispatch(mailActions.doModifyInitSenderStr(selectedEmail || ''));
                        }
                    }
                }
                catch (error) {
                    console.log('reInitMail error', error);
                }
            }
        }
        selectedEmailRef.current = selectedEmail;
    };
    const handleMenuClick = (e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        e === null || e === void 0 ? void 0 : e.preventDefault();
        const item = selectableAccounts.filter(it => it.id === e.target.value).pop();
        if ((!praiseMailShow && !taskMailShow) || (item && item.isMainAccount)) {
            item && setOptSenderAction(item.id);
            return;
        }
        SiriusModal.confirm({
            title: '确定切换账号？',
            className: 'no-content-confirm',
            icon: React.createElement(AlertErrorIcon, null),
            content: React.createElement("span", null, "\u5F53\u524D\u5207\u6362\u7684\u8D26\u53F7\u4E0D\u652F\u6301\u4EFB\u52A1/\u8868\u626C\u90AE\u4EF6/\u5DF2\u8BFB\u63D0\u9192\u529F\u80FD\uFF0C\u5207\u6362\u8D26\u53F7\u540E\uFF0C\u4EC5\u4FDD\u7559\u6B63\u6587\u5185\u5BB9"),
            okType: 'danger',
            onOk: () => {
                item && setOptSenderAction(item.id);
            },
        });
    };
    const handleNicknameChangeButton = useCallback(e => {
        e.stopPropagation();
        e.preventDefault();
        setIsEditting(true);
        setTimeout(() => {
            inputRef.current.focus({
                cursor: 'all',
            });
        }, 200);
    }, [inputRef]);
    const handleNicknameChangeBlur = useCallback(async (e) => {
        var _a;
        const val = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
        if (val !== curAccount.senderName) {
            if (curAccount.isMainEmail) {
                if (val) {
                    if (curAccount.isSubAccount) {
                        await accountApi.editSubAccountNickName({ email: curAccount.id, nickName: val });
                    }
                    else {
                        await mailConfApi.setMailSenderName(val.trim(), curAccount.mailEmail);
                    }
                }
            }
            else {
                await mailConfApi.doUpdatePOPAccounts([{ id: curAccount.editId || 0, name: val.trim() }], curAccount.mailEmail);
            }
            await getSelectableAccounts();
            setOptSenderAction(curAccount.id);
        }
        setIsEditting(false);
    }, [curAccount]);
    const handleSenderSetting = useCallback(e => {
        setShowSenderSettingDialog(true);
        setDropdownVisible(false);
    }, []);
    const handleSenderSettingSubmit = useCallback(async (hasChanged) => {
        if (hasChanged) {
            await getSelectableAccounts();
            setOptSenderAction(curAccount.id);
        }
    }, [getSelectableAccounts, curAccount]);
    const handleNicknameDialogVisible = useCallback((val) => {
        setShowSenderSettingDialog(val);
    }, []);
    const throttleGetAccounts = useCallback(throttle(() => getSelectableAccounts(), 5000, { trailing: false }), []);
    const handleMenuVisibleChange = useCallback((visible) => {
        if (!visible && isEditting) {
            setIsEditting(false);
        }
        setDropdownVisible(visible);
        if (visible) {
            try {
                throttleGetAccounts();
            }
            catch (error) {
                console.log(error);
            }
        }
    }, []);
    const initSender = async () => {
        var _a;
        const allAccounts = await getSelectableAccounts();
        const mainAccount = allAccounts.find((account) => !!account.isMainAccount);
        const defAccount = allAccounts.find(item => item.isDefault);
        let email = '';
        const optSender = (_a = currentMail === null || currentMail === void 0 ? void 0 : currentMail.optSender) === null || _a === void 0 ? void 0 : _a.id;
        const { optSenderStr, initSenderStr } = currentMail;
        if (optSender || optSenderStr) {
            email = optSender || optSenderStr || '';
        }
        else {
            if (initSenderStr === (mainAccount === null || mainAccount === void 0 ? void 0 : mainAccount.mailEmail)) {
                email = (defAccount === null || defAccount === void 0 ? void 0 : defAccount.id) || initSenderStr;
            }
            else {
                email = initSenderStr;
            }
        }
        selectedEmailRef.current = email;
        setOptSenderAction(email);
    };
    useEffect(debounce(() => {
        initSender();
    }, 200), [currentMailId]);
    const menu = (React.createElement(Menu, { className: style.senderMenu },
        React.createElement(OverlayScrollbarsComponent, { style: { maxHeight: '300px' } },
            React.createElement(Radio.Group, { value: curAccount.id, style: { width: '100%' }, onChange: handleMenuClick }, selectableAccounts.map(it => (React.createElement(Menu.Item, { key: it.id, className: it.id === (curAccount === null || curAccount === void 0 ? void 0 : curAccount.id) ? 'current' : '', style: it.id === (curAccount === null || curAccount === void 0 ? void 0 : curAccount.id) ? { color: 'rgba(56, 110, 231, 1)', width: '100%' } : { width: '100%' } },
                React.createElement(Radio, { value: it.id },
                    React.createElement(AccountTag, { account: Object.assign(Object.assign({}, it), { isSelected: it.id === (curAccount === null || curAccount === void 0 ? void 0 : curAccount.id) }) }))))))),
        React.createElement(Menu.Item, { className: style.senderMenuEditField },
            React.createElement("div", { className: style.senderMenuEditFieldTitle },
                React.createElement("span", null, getIn18Text('FAJIANNICHENG')),
                ' ',
                isEditting ? (React.createElement(Input, { defaultValue: tempNickName, ref: inputRef, className: style.senderMenuInput, maxLength: 12, onPressEnter: keydownAction, onBlur: handleNicknameChangeBlur, onKeyPress: e => e.stopPropagation(), onKeyDown: e => e.stopPropagation() })) : (React.createElement("span", { className: style.senderMenuCurrName }, util.chopStrToByteSize((curAccount === null || curAccount === void 0 ? void 0 : curAccount.senderName) || '', 24))),
                ' ',
                !hideNickname && (curAccount.isMainEmail || curAccount.isProxy) && (React.createElement("a", { className: style.senderMenuEditButton, hidden: isEditting, onClick: handleNicknameChangeButton }, getIn18Text('XIUGAINICHENG'))),
                !hideNickname && (React.createElement(Tooltip, { getPopupContainer: element => element.parentElement || document.body, placement: "top", title: getIn18Text('FAJIANRENSHEZHI') },
                    React.createElement("div", { onClick: handleSenderSetting, className: style.senderMenuBottomItem },
                        React.createElement(NicknameSettingIcon, { className: style.nicknameSettingIcon, stroke: isEditting ? '#386EE7' : '' }))))))));
    const showName = `${curAccount === null || curAccount === void 0 ? void 0 : curAccount.senderName} ${curAccount.isSubAccount ? curAccount.agentEmail || (curAccount === null || curAccount === void 0 ? void 0 : curAccount.id) : curAccount === null || curAccount === void 0 ? void 0 : curAccount.id}`;
    return (React.createElement(React.Fragment, null,
        React.createElement(Dropdown, { overlay: menu, trigger: ['click'], getPopupContainer: node => node.parentElement || document.body, onVisibleChange: handleMenuVisibleChange, visible: dropdownVisible, placement: "topLeft" },
            React.createElement("span", { style: { cursor: 'pointer' } },
                React.createElement("span", { className: style.senderShowName, title: showName },
                    getIn18Text('FAJIANREN：'),
                    util.chopStrToByteSize(showName, 22),
                    "\u00A0"),
                React.createElement(IconCard, { type: "upTriangle" }))),
        !hideNickname && (React.createElement(MailSenderSetting, { isShow: showSenderSettingDialog, handleSubmit: handleSenderSettingSubmit, type: SenderSettingType.SENDER_SETTING, setVisible: handleNicknameDialogVisible }))));
};
const SenderSelectComp = (props) => {
    const { setSender } = props;
    const senderChanged = (item) => {
        if (!item)
            return;
        trackApi.track('pcMail_click_switchSender__writeMailPage');
        if (!item.nickName && item.senderName) {
            item.nickName = item.senderName;
        }
        setSender(item);
    };
    return (React.createElement("div", { className: `${style.sender}` },
        React.createElement(SenderSelect, { selectChanged: senderChanged })));
};
export default SenderSelectComp;
